module.exports = __webpack_public_path__ + "static/GreycliffCF-ExtraBold-b854e1b6d104c8d9d83f4f44e542e5c1.ttf";